// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img-content[data-v-80d2e524]{min-width:160px;max-width:160px;height:100px;max-height:-webkit-max-content;max-height:-moz-max-content;max-height:max-content}", ""]);
// Exports
module.exports = exports;
